import React, { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import styles from "./ApplicationsPage.module.scss";
import LeadDetails from "../../Molecules/detailsBox/leadDetailsBox";
import TableTopHeader from "../../Molecules/TableTopHeader/ApplicationsTableTopHeader";
import ApplicantsTable from "../../Molecules/Applications/ApplicantsTable";
import { PageTitleContext } from "../../HOC/GeneralBody/GeneralBody";
import {
  useFetchLeads,
  useExportTableLeads,
  useFetchSingleLead,
} from "../../../Hooks/Applications";

const ApplicationsPage = () => {
  const [Page, setPage] = useState(1);
  const [PageSize, setPageSize] = useState(10);
  const HeaderAttr = useContext(PageTitleContext);

  const [selected, setSelected] = useState("leads");
  const [leadsNumber, setLeadsNumber] = useState(0);

  const [applicationId, setApplicationId] = useState("");

  let componentRef = useRef();

  const applicantsTableHeader = [
    {
      name: "First Name",
      originalName: "firstName",
    },
    {
      name: "Last Name",
      originalName: "lastName",
    },
    {
      name: "Email",
      originalName: "email",
    },
    {
      name: "Phone",
      originalName: "phoneNumber",
    },
    {
      name: "Degree Type",
      originalName: "degreeType",
    },
  ];

  const [search, setSearch] = useState();
  const [order, setOrder] = useState(["", "asc"]);
  const [mode, setMode] = useState("leads");
  const [details, setDetails] = useState("");
  const { id } = useParams();

  const {
    data: leads,
    refetch: refetchLeads,
    isLoading: isLoading,
  } = useFetchLeads({
    pageSize: PageSize,
    pageNumber: Page,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const {
    data: leadsPrint,
    refetch: refetchLeadsPrint,
    isLoading: isLoading000,
  } = useFetchLeads({
    pageSize: 10000,
    pageNumber: 1,
    search: search,
    OrderBy: order[0],
    OrderDir: order[1],
  });

  const { data: LeadbyId, refetch: refetchSingleLead } =
    useFetchSingleLead(details);
  //********************************* */

  //---------------------------------exportTables All
  const exportLeadsTable = useExportTableLeads();
  const handleExportTable = async () => {
    try {
      var data = await exportLeadsTable.mutateAsync();

      if (data.data instanceof Blob) {
        const blob = new Blob([data.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "LeadsTable";
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        console.error("Unexpected data type. Expected string.");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  //-------------------------------------

  useEffect(() => {
    if (details) {
      HeaderAttr.setMoveRight("40px");

      refetchSingleLead();
      HeaderAttr.setPathName("Lead Details");
    } else {
      HeaderAttr.setMoveRight("2px");
      HeaderAttr.setPathName("Leads");
    }
  }, [details]);

  useEffect(() => {
    refetchLeads();
  }, [Page, PageSize, search, order]);

  useEffect(() => {
    if (leads && !leadsNumber) {
      setLeadsNumber(leads && leads.data.totalCount);
    }
  }, [leads]);

  const [moveRight, setMoveRight] = useState(false);

  useEffect(() => {
    setSearch("");
    setPage(1);
    setPageSize(10);
    setOrder(["", "asc"]);
  }, [selected]);

  useEffect(() => {}, []);

  return (
    <>
      {!details ? (
        <div className={styles["container"]}>
          <div className={styles["search-container"]}>
            <div className={styles["table-container"]}>
              <TableTopHeader
                rowsCount={leads}
                mode={mode}
                handleExport={handleExportTable}
                search={search}
                setSearch={setSearch}
                data={leadsPrint?.data}
                refetch={refetchLeadsPrint}
                tableHeader={applicantsTableHeader}
                title="Leads Table"
              />
              <ApplicantsTable
                data={leads?.data}
                tableHeader={applicantsTableHeader}
                mode={mode}
                page={Page}
                setPage={setPage}
                pageSize={PageSize}
                setPageSize={setPageSize}
                isApplicantsLoading={isLoading}
                setDetails={setDetails}
                setApplicationId={setApplicationId}
                details={details}
                order={order}
                setOrder={setOrder}
                refetch={refetchLeads}
                setMoveRight={setMoveRight}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      ) : (
        <>
          <LeadDetails
            data={LeadbyId && LeadbyId.data}
            setDetails={setDetails}
            details={details}
            setMoveRight={setMoveRight}
            moveRight={moveRight}
          />
        </>
      )}
    </>
  );
};

export default ApplicationsPage;
